import {
	type TrackVariants,
	thumb,
	track as trackStyles,
	wrapper,
} from "./Toggle.css";

interface ToggleSwitchProps {
	checked: boolean;
	focused: boolean;
}

export function ToggleSwitch({
	checked,
	focused,
	track,
}: ToggleSwitchProps & TrackVariants) {
	return (
		<div className={wrapper}>
			<div className={trackStyles({ checked, track })}>
				<span className={thumb({ checked, focused })} />
			</div>
		</div>
	);
}
